<template>
  <component v-if="!loading" :is="selectedStep" />
</template>

<script>
import ApiUrls from '../api-url';
import AuthenticationMixin from '../authentication-mixin';
import LoginForm from './signin/login-form';
import SignUpCreateAccount from './signup/sign-up-create-account';
import SignUpPaymentInfo from './signup/sign-up-payment-info';
import getters from '../stores/login-store/getters/login-getters';
import BookACall from './signup/book-a-call.vue';
import AfterSignup from './signup/after-signup.vue';
import SendYourPhone from './signup/send-your-number.vue';
import SignUpCoachInfo from './signup/sign-up-coach-info.vue';
import SignUpBuildSelection from './signup/sign-up-build-selection.vue';
import SignUpDownloadApp from './signup/sign-up-download-app.vue';
import { mapState } from 'vuex';

export default {
  mixins: [ApiUrls, AuthenticationMixin],
  components: {
    LoginForm,
    SignUpCreateAccount,
    SignUpPaymentInfo,
    AfterSignup,
    BookACall,
    SendYourPhone,
    SignUpCoachInfo,
    SignUpBuildSelection,
    SignUpDownloadApp,
  },
  data() {
    return {
      billingInfo: {
        trial_amount: 0,
        trial_days: 0,
      },
      loading: false,
      user: {},
    };
  },
  async created() {
    this.loading = true;
    if (this.$route.name === 'SignupPage') {
      this.$store.commit('setSelectedStep', getters.SIGN_UP_CREATE_ACCOUNT());
    } else if (this.$route.name === 'CompleteSignupPage') {
      this.$store.commit('setSelectedStep', getters.SIGN_UP_COACH_INFO());
    } else if (this.$route.name === 'SigninPage') {
      this.$store.commit('setSelectedStep', getters.LOGIN_FORM());
    }
    await this.getRequestedOrganization();
    await this.getData();
    if (this.$route.name === 'CompleteSignupPage') {
      await this.fetchSignupProgress();
    }
    this.loading = false;
  },
  computed: {
    ...mapState(['selectedStep']),
  },
  methods: {
    async getData() {
      const { data } = await this.axiosInstance.get(`${this.billingUrl}get_system_billing_settings`);
      this.billingInfo = data.result;
      this.setUpComponents();
    },
    async getRequestedOrganization() {
      const org_subdomain = window.location.host.split('.')[0];
      const { data } = await this.axiosInstance.post(`${this.organizationUrl}requested_organization`, { org_subdomain });
      if (data.success) {
        await this.$store.commit('setRequestedOrganization', data.result);
      }
    },
    async fetchSignupProgress() {
      try {
        const { data } = await this.axiosInstance.get(this.organizationUrl + 'get_signup_info');
        if (!data.success || !data.result) return;
        const result = data.result;
        const userForm = {
          name: result.name || '',
          signup_coach_type: result.signup_coach_type || '',
          signup_clients: result.signup_clients || '',
          signup_coaching_style: result.signup_coaching_style || '',
          signup_teammates: result.signup_teammates || '',
        };
        this.$store.commit('setUserForm', userForm);
        if (!result.name || result.name.toString().trim() === '') {
          this.$store.commit('setSelectedStep', getters.SIGN_UP_COACH_INFO());
        } else if (!result.signup_build_type || result.signup_build_type.toString().trim() === '') {
          this.$store.commit('setSelectedStep', getters.SIGN_UP_BUILD_SELECTION());
        } else {
          this.$store.commit('setSelectedStep', getters.SIGN_UP_DOWNLOAD_APP());
        }
      } catch (error) {
        // Keep default step (Coach Info) on error
      }
    },
    setUpComponents() {
      const amount = parseInt(this.billingInfo.trial_amount) || 0;
      this.$store.commit('setTrialAmount', amount);
      this.$store.commit('setTrialDays', this.billingInfo.trial_days);
    },
  },
};
</script>
